import React, { useState, useCallback, Fragment } from 'react';
import Img from '../../../../../../components/Img';
import Slider from '../../../../../../components/utils/Slider/Slider';
import WidgetPreviewStoreItem from '../WidgetPreviewStoreItem';
import './WidgetPreviewStoreSwipeLayout.scss';

const WidgetPreviewStoreSwipeLayout = (props) => {
  const { list, layoutType } = props;

  /**
   *  함수형 컴포넌트에서 사용될 state 초기화
   */
  const [swipeIndex, setSwipeIndex] = useState(0);

  /**
   *  slider before onchange event 가 발생을 할 때마다
   *  swipeIndex 를 업데이트 함
   */
  const onChange = useCallback((oldIndex, newIndex) => {
    setSwipeIndex(newIndex);
  }, []);

  return (
    <Fragment>
      <Slider
        className="widget-store-swipe-layout"
        list={list}
        arrows={false}
        beforeChange={onChange}
        infinite={false}
        item={(storeItem) => <Img clickAble={false} src={storeItem.url} />}
      />

      <WidgetPreviewStoreItem layoutType={layoutType} storeItem={list[swipeIndex]} />
    </Fragment>
  );
};

export default WidgetPreviewStoreSwipeLayout;
